var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',[_c('span',{attrs:{"title":_vm.version.concat(' - ').concat(_vm.buildtime)}},[_vm._v("©")]),_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Alerce")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }